import _objectSpread from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _awaitAsyncGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _wrapAsyncGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
import { r as replaceTraps, i as instanceOfAny, a as reverseTransformCache, u as unwrap } from './wrap-idb-value.js';
var advanceMethodProps = ['continue', 'continuePrimaryKey', 'advance'];
var methodMap = {};
var advanceResults = new WeakMap();
var ittrProxiedCursorToOriginalProxy = new WeakMap();
var cursorIteratorTraps = {
  get: function get(target, prop) {
    if (!advanceMethodProps.includes(prop)) return target[prop];
    var cachedFunc = methodMap[prop];

    if (!cachedFunc) {
      cachedFunc = methodMap[prop] = function () {
        var _ittrProxiedCursorToO;

        advanceResults.set(this, (_ittrProxiedCursorToO = ittrProxiedCursorToOriginalProxy.get(this))[prop].apply(_ittrProxiedCursorToO, arguments));
      };
    }

    return cachedFunc;
  }
};

function iterate() {
  return _iterate.apply(this, arguments);
}

function _iterate() {
  _iterate = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var cursor,
        _cursor,
        proxiedCursor,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // tslint:disable-next-line:no-this-assignment
            cursor = this;

            if (cursor instanceof IDBCursor) {
              _context.next = 5;
              break;
            }

            _context.next = 4;
            return _awaitAsyncGenerator((_cursor = cursor).openCursor.apply(_cursor, _args));

          case 4:
            cursor = _context.sent;

          case 5:
            if (cursor) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return");

          case 7:
            cursor = cursor;
            proxiedCursor = new Proxy(cursor, cursorIteratorTraps);
            ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor); // Map this double-proxy back to the original, so other cursor methods work.

            reverseTransformCache.set(proxiedCursor, unwrap(cursor));

          case 11:
            if (!cursor) {
              _context.next = 20;
              break;
            }

            _context.next = 14;
            return proxiedCursor;

          case 14:
            _context.next = 16;
            return _awaitAsyncGenerator(advanceResults.get(proxiedCursor) || cursor.continue());

          case 16:
            cursor = _context.sent;
            advanceResults.delete(proxiedCursor);
            _context.next = 11;
            break;

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _iterate.apply(this, arguments);
}

function isIteratorProp(target, prop) {
  return prop === Symbol.asyncIterator && instanceOfAny(target, [IDBIndex, IDBObjectStore, IDBCursor]) || prop === 'iterate' && instanceOfAny(target, [IDBIndex, IDBObjectStore]);
}

replaceTraps(function (oldTraps) {
  return _objectSpread({}, oldTraps, {
    get: function get(target, prop, receiver) {
      if (isIteratorProp(target, prop)) return iterate;
      return oldTraps.get(target, prop, receiver);
    },
    has: function has(target, prop) {
      return isIteratorProp(target, prop) || oldTraps.has(target, prop);
    }
  });
});